const moment = require('moment');
require('moment/locale/es');

moment.locale('es');

/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
function formatNumber(param, n, x, s, c) {
  const value = Number(param);

  const re = `\\d(?=(\\d{${x || 3}})+${n > 0 ? '\\D' : '$'})`;
  /* eslint no-bitwise: ["error", { "allow": ["~"] }] */
  const num = value.toFixed(Math.max(0, ~~n));

  return (c ? num.replace('.', c) : num).replace(
    new RegExp(re, 'g'),
    `$&${s || ','}`
  );
}

function formatPercentage(number) {
  let value = 0;

  if (number !== undefined && number !== '') {
    value = formatNumber(number, 2, 3, '.', ',');
  } else {
    return '';
  }

  return String(value).concat(' %');
}

function formatCurrency(money) {
  let value = 0;

  if (money !== undefined && money !== '') {
    value = formatNumber(money, 0, 3, '.', ',');
  } else {
    return '';
  }

  return '$'.concat(value);
}

function formatDate(date, pattern) {
  if (date !== undefined && date !== '') {
    return moment(date).format(pattern || 'DD/MM/YYYY');
  }
  return '';
}
function cleanFormatDate(date){
  return moment(date).format("YYYYMMDD");
}

function cleanNumberFormat(number) {
  const numeroSinFormato =
    typeof number === 'number' ? number : number.replace(/[^0-9]/g, '');
  return numeroSinFormato;
}

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export { formatPercentage, formatCurrency, formatDate, cleanNumberFormat, capitalize, cleanFormatDate };
